if (!customElements.get('quick-add-trigger')) {
  customElements.define(
    'quick-add-trigger',
    class QuickAddTrigger extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.addEventListener('click', this);
      }

      handleEvent(event) {
        event.preventDefault();
        const card = this.closest('.card-wrapper');
        if (!card) return;

        const submit = card.querySelector('.quick-add__submit');
        if (submit && !submit.disabled) {
          submit.click();
          return;
        }

        const bulkPlus = card.querySelector('quick-add-bulk .quantity__button[name="plus"]');
        if (bulkPlus) bulkPlus.click();
      }
    }
  );
}
